// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface EventCardProps {
	bgColor: 'light' | 'dark'
	img?: {
		src?: string
		alt?: string
	}
	startDate?: string
	endDate?: string
	title: string
	location?: string
	stand?: string
	href?: {
		text: string
		url: string
		isExternal?: boolean
	}
}

export default function EventCard({
   bgColor,
   img,
   startDate,
   endDate,
   title,
   location,
   stand,
   href
}: EventCardProps) {
	return (
		<div className={clsx(
			'event-card',
			!img?.src && 'event-card--no-image'
		)}>

			<div className='event-card__image'>
				{img?.src && (
					<div className={clsx(
						'cover',
						bgColor === 'dark' && 'bg--dark',
						bgColor === 'light' && 'bg--light'
					)}>
						<Image
							src={img.src} // 450x300
							alt={img.alt}
							className='cover'
						/>
					</div>
				)}
			</div>

			<div className='event-card__content'>

				<div className='event-card__date'>

					{isNonWhitespaceString(startDate) && (
						<p className='text-md'>
							{startDate}
						</p>	
					)}

					{/* isNonWhitespaceString(endDate) && (
						<p className='text-md'>
							- {endDate}
						</p>	
					) */}

				</div>

				{isNonWhitespaceString(title) && (
					<p className='event-card__title text-lg'>
						{title}
					</p>	
				)}

				{isNonWhitespaceString(location) && (
					<p className='event-card__location text-md'>
						{location}
					</p>	
				)}

				{isNonWhitespaceString(stand) && (
					<p className='event-card__stand text-md'>
						Stand: {stand}
					</p>	
				)}

				{isNonWhitespaceString(href?.url) && (
					<a
						href={href.url}
						target={href?.isExternal ? '_blank' : undefined}
						className='event-card__link text-sm'
					>
						{href.text} <svg width='11' height='11' viewBox='0 0 11 11' xmlns='http://www.w3.org/2000/svg'><path d='M10.4897 1.99996L1.49972 10.9899L0.509766 9.99996L9.49971 1.01001L10.4897 1.99996Z M2.7998 0.800049H10.6998V8.70005H9.2998V2.20005H2.7998V0.800049Z'/></svg>
					</a>
				)}

			</div>

		</div>
	)
}